import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { pxToRem } from '../../../assets/styles/helper';
import themeColors from '../../../assets/styles/themeColors';
import { variables } from '../../../assets/styles/variables';
import BottomDrawer from '../../Drawer/Drawer';
import Button from '../../Button/Button';

const StepsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(16)};
  padding: ${pxToRem(8)} 0;
`;

const StepItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(4)};
`;

const StepTag = styled.span`
  display: inline-block;
  background-color: ${themeColors.colorTextSecondary};
  color: ${themeColors.colorWhite};
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: ${pxToRem(12)};
  font-weight: 600;
  border-radius: ${pxToRem(4)};
  padding: ${pxToRem(2)} ${pxToRem(8)};
  width: fit-content;
`;

const StepTitle = styled.p`
  font-size: ${pxToRem(14)};
  font-weight: 700;
  color: ${themeColors.colorTextPrimary};
  margin: 0;
`;

const StepDescription = styled.p`
  font-size: ${pxToRem(14)};
  font-weight: 400;
  color: ${themeColors.colorTextSecondary};
  line-height: 1.5;
  margin: 0;
`;

const DrawerFooter = styled.div`
  > button {
    width: 100%;
    color: ${themeColors.colorPrimary};
  }
`;

const SellFromHomeStepsDrawer = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  const footer = (
    <DrawerFooter>
      <Button variant="primaryOutlined" textTransform="none" onClick={onClose}>
        {t('sellWizard.sellFromHomeSteps.cta')}
      </Button>
    </DrawerFooter>
  );

  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={onClose}
      title={t('sellWizard.sellFromHomeSteps.title')}
      subtitle={t('sellWizard.sellFromHomeSteps.subtitle')}
      footer={footer}
      maxHeight="70%"
    >
      <StepsList>
        <StepItem>
          <StepTag>{t('sellWizard.sellFromHomeSteps.step1.tag')}</StepTag>
          <StepTitle>{t('sellWizard.sellFromHomeSteps.step1.title')}</StepTitle>
          <StepDescription>
            {t('sellWizard.sellFromHomeSteps.step1.description')}
          </StepDescription>
        </StepItem>
        <StepItem>
          <StepTag>{t('sellWizard.sellFromHomeSteps.step2.tag')}</StepTag>
          <StepTitle>{t('sellWizard.sellFromHomeSteps.step2.title')}</StepTitle>
          <StepDescription>
            {t('sellWizard.sellFromHomeSteps.step2.description')}
          </StepDescription>
        </StepItem>
      </StepsList>
    </BottomDrawer>
  );
};

SellFromHomeStepsDrawer.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default SellFromHomeStepsDrawer;
